import { Box, ButtonBase, makeStyles, Typography } from "@material-ui/core";
import React, { useContext, useState } from "react";
import SettingsOutlined from "@material-ui/icons/SettingsOutlined";
import Checkbox from "@material-ui/core/Checkbox";
import CustomDialog from "../../../components/Dialog/CustomDialog";
import { useSelectedColumns } from "../../../contexts/SelectedColumnsContext";
import { tesaGrey1 } from "../../../styles/colors";
import TestRequestOverviewColumns, * as OverviewColumns from "./TestRequestsOverviewColumns";
import GenericPermissionContext from "../../../contexts/GenericPermissionContext";

const useStyles = makeStyles({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  checkableLine: {
    display: "flex",
    alignItems: "center",
  },
  icon: {
    color: tesaGrey1,
    fontSize: "1.25rem",
    marginRight: "10px",
  },
  optionCheckbox: {
    padding: 0,
    marginRight: "12px",
  },
  optionLabel: {
    alignItems: "center",
    display: "flex",
    whiteSpace: "pre",
  },
  text: {
    color: tesaGrey1,
    fontSize: "0.875rem",
    fontFamily: "Proxima Nova",
  },
});

function OverviewColumnsSelector() {
  const classes = useStyles();
  const { selectedColumns, updateSelectedColumns } = useSelectedColumns();
  const [dialogOpen, setDialogOpen] = useState(false);

  const permissions = useContext(GenericPermissionContext);

  const toggleDialog = () => {
    setDialogOpen(!dialogOpen);
  };

  const CheckableLine = (props: { label: string; value: TestRequestOverviewColumns }) => (
    <Box className={classes.checkableLine}>
      <Checkbox
        style={{ marginRight: "5px", marginLeft: "-10px" }}
        checked={selectedColumns?.indexOf(props.value) > -1}
        onChange={() => {
          updateSelectedColumns(props.value);
        }}
      />
      <div>{props.label}</div>
    </Box>
  );

  const { configurableColumns, columnsDictionary } = OverviewColumns;

  const canViewPriority = !!permissions?.newTestRequest?.description?.viewTestRequestPriority;

  return (
    <>
      <ButtonBase className={classes.root} onClick={toggleDialog}>
        <SettingsOutlined className={classes.icon} />
        <Typography className={classes.text}>Configure Columns</Typography>
      </ButtonBase>
      <CustomDialog open={dialogOpen} onClose={toggleDialog} fullWidth maxWidth="xs">
        <h2>CONFIGURE COLUMNS</h2>
        {configurableColumns
          .filter((column) => column !== "priority" || canViewPriority)
          .map((column) => (
            <CheckableLine key={column} value={column} label={columnsDictionary?.[column] ?? column} />
          ))}
      </CustomDialog>
    </>
  );
}

export default OverviewColumnsSelector;
